import React from 'react';
import { cnBem } from "../../../../shared/lib";
import { withMessageWrapper } from "../../lib";
import styles from "./styles.pcss";
var cnLocationView = cnBem('location', styles);
var LocationViewRender = function LocationViewRender() {
  return /*#__PURE__*/React.createElement("div", null);
};
export var LocationView = withMessageWrapper({
  bordered: true,
  dateView: 'block',
  offset: 'none',
  wrapperClassName: cnLocationView()
})(LocationViewRender);